var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inroom cursor-pointer",class:{
        wide: _vm.wide
    },on:{"click":_vm.open}},[_c('div',{staticClass:"label f-small fw-600",class:_vm.labelClass},[_vm._t("default")],2),_vm._v(" "),_c('ul',{staticClass:"users"},[_vm._l((_vm.showUsers),function(user){return _c('li',{key:user.id,staticClass:"user",class:{
                'f-shadow': _vm.wide
            }},[_c('WebpPicture',{attrs:{"src":user.photo,"alt":user.name,"width":"24","height":"24","decoding":"async"}})],1)}),_vm._v(" "),(_vm.users.length > _vm.maxLength)?_c('li',{staticClass:"user more"},[_c('span',[_vm._v("+"+_vm._s(_vm.users.length-_vm.maxLength))])]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }